


































































































import { Component, Vue } from 'vue-property-decorator';
import { changeLoading } from '@/util/plugins';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const getUrl = require('baimahu/url-with-param');
const dateFormat = require('bmh/date-format');
const API = {
  get_list: `${FCAPI}/shang/ruan/sample`,
  get_cummunity_list: `${FCAPI}/shang/ruan/community/name`,
  edit_sample: `${FCAPI}/shang/ruan/sample`,
};
const STATUS = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 1,
    label: '上架中',
  },
  {
    value: 2,
    label: '已下架',
  },
];
function initForm() {
  return {
    name: '',
    community_id: undefined,
    status: 0,
  };
}
function initData(remote?: any) {
  remote = remote || {};
  return {
    current: remote.current || 0,
    detail: remote.detail || [],
    last: remote.last || 0,
    limit: remote.limit || 0,
    total: remote.total || 0,
  };
}
@Component
export default class CommunityTemplate extends Vue {
  active_index: number = -1;
  community_data: any = [];
  is_loading: boolean = false;
  old_value: string = '';
  table_data: any = initData();
  form: any = initForm();
  get status() {
    return STATUS;
  }

  // 跳转新增页面
  toAddPage(record: any) {
    const url = record.id ? `/operation/add-template-room?id=${record.id}` : '/operation/add-template-room';
    this.$router.push(url);
  }

  paginationOption(data: any) {
    return {
      showTotal: () => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 0,
      total: data.total || 0,
      current: data.current || 0,
    };
  }

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }

  // 关闭修改排序输入框
  closeInput(record: any) {
    this.active_index = -1;
    record.sort = this.old_value;
    this.old_value = '';
  }

  // 展示修改排序输入框
  showInput(index: number, record: any) {
    this.active_index = index;
    this.old_value = record.sort;
  }

  // 清空搜索框
  clearForm() {
    this.form = initForm();
  }

  // 切换分页
  @changeLoading(['is_loading'])
  async handleChange(data: any) {
    const form = this.form;
    await this.getSampleList({
      name: form.name,
      community_id: form.community_id,
      is_show: form.status,
      current: data.current,
    });
  }

  // 获取小区列表
  @changeLoading(['is_loading'])
  async getCommunityList() {
    const res = await this.$axios.get(API.get_cummunity_list);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.community_data = res.data.data;
  }

  // 获取样板间列表
  @changeLoading(['is_loading'])
  async getSampleList(query_params?: any) {
    const url = getUrl(API.get_list, query_params);
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.table_data = initData(res.data.data);
  }

  // 更改排序值
  @changeLoading(['is_loading'])
  async changeSort(record: any) {
    const res = await this.$axios.put(`${API.edit_sample}/${record.id}`, {
      sort: record.sort,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.active_index = -1;
    await this.getSampleList();
  }

  // 更改上下架状态
  @changeLoading(['is_loading'])
  async changeStatus(record: any) {
    const res = await this.$axios.put(`${API.edit_sample}/${record.id}`, {
      is_show: record.is_show === 1 ? 2 : 1,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    await this.getSampleList();
  }
  // 点击搜索按钮
  @changeLoading(['is_loading'])
  async clickSearchBtn() {
    const form = this.form;
    await this.getSampleList({
      name: form.name,
      community_id: form.community_id,
      is_show: form.status,
    });
  }

  @changeLoading(['is_loading'])
  async created() {
    await this.getCommunityList();
    await this.getSampleList();
  }
}
